const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', label: 'No.' },
    // { key: 'group.groupname', sortable: true, label: 'Group' },
    { key: 'permissions', label: 'Permissions' },
    { key: 'is_alive', label: 'Available' },
    { key: 'username', sortable: true, label: 'Username'},
    { key: 'nickname', sortable: true, label: 'Nickname' },
    { key: 'last_visit', label: 'Last Login', sortable: true },
    // { key: 'func', label: 'Detail', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', label: 'No.' },
    // { key: 'group.groupname', sortable: true, label: 'Group' },
    { key: 'permissions', label: '권한' },
    { key: 'is_alive', label: '사용여부' },
    { key: 'username', sortable: true, label: '아이디'},
    { key: 'nickname', sortable: true, label: '이름' },
    { key: 'last_visit', label: '마지막 로그인', sortable: true },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP: [
    { key: 'id', thStyle: 'width: 10%', label: 'No.' },
    // { key: 'group.groupname', sortable: true, label: 'グループ' },
    { key: 'permissions', label: '権限' },
    { key: 'is_alive', label: '利用可能' },
    { key: 'username', sortable: true, label: 'ユーザー名'},
    { key: 'nickname', sortable: true, label: 'ニックネーム' },
    { key: 'last_visit', label: '最終ログイン', sortable: true },
    // { key: 'func', label: '詳細', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const i18n_field = {
  i18n_fields
}

export default i18n_field